import { DataBean } from "../DataBean";

export class SIIFAuxiliaryType extends DataBean {


    public async getSIIFAuxiliaryTypeCatalog(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSIIFAuxiliaryTypeCatalog_Number", [id]);
    }

 
}